import React, { Component } from 'react';
import DataTablesCreate from '../components/DataTablesCreate';
import {ApiClient, ApiResponse} from '../libs/apiClient';
import {DISPATCH_ID, SERVICE_RESPONSE} from '../libs/utils/Const';
import {connect} from 'react-redux';
import '../css/dataTables.css';
import $ from 'jquery';

let headers = [
    {title: 'Código'},
    {title: 'Nombre'}
];
let apiClient = ApiClient.getInstance();
class VendorsModal extends Component {
    constructor(props){
        super(props);
        this.state = {
           searchInTable:''
        }

    }

    componentDidMount(){
        this.closeAction();
    }    
    
    closePartner = async () => {
        $('#VendorsModal').modal('hide');
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#VendorsModal').on('hide.bs.modal', function () {
            cleanData();
        });
    };

    render() {
         const {data, vendorData,  totalPage, showAlert, selectBusinessParter } = this.props;
         let CardCode = '';
         if(vendorData){
            CardCode = vendorData.CardCode || '';
         }
          
         if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="VendorsModal"></div>;
         }

        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll"
                id="VendorsModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true">

                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Proveedores
                            </h4>
                            <button type="button" className="close" onClick={this.closePartner} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className="table response" style={{marginBottom: 0}}>
                                                <tbody>
                                                <DataTablesCreate data={data} totalPage={totalPage} headers={headers} view={"VendorsModal"} searchInTable={CardCode} action={selectBusinessParter} showAlert={showAlert} />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">       
                             <button type="button" className="btn botonCerrar text-white" onClick={this.closePartner} >Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
) (VendorsModal);